export const getObjectKeyFromValue = (obj, val) => { // eslint-disable-line
    return Object.keys(obj)
        .slice()
        .find(key => obj[key] === val); // eslint-disable-line
};

export default getObjectKeyFromValue;
